import { useState, useEffect } from "react";

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { label: "我是誰", href: "#who-i-am" },
    { label: "如何幫助", href: "#how-i-help" },
    { label: "最新觀察", href: "#insights" },
    { label: "合作流程", href: "#how-it-works" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm border-b border-stone-100" : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <a href="#hero" className="flex items-center gap-2 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/76f94b045f9b93f74f066d244037d990/428c6cd2fb47a0ddcb957948b924a1cf.png"
            alt="Logo"
            className="h-9 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? "text-stone-600 hover:text-stone-900" : "text-white/80 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#submit"
            className="bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold px-5 py-2 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            提交項目
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer p-1"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span className={`block w-6 h-0.5 transition-all ${scrolled ? "bg-stone-800" : "bg-white"}`} />
          <span className={`block w-6 h-0.5 transition-all ${scrolled ? "bg-stone-800" : "bg-white"}`} />
          <span className={`block w-6 h-0.5 transition-all ${scrolled ? "bg-stone-800" : "bg-white"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-stone-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-stone-700 hover:text-stone-900 cursor-pointer"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#submit"
            className="bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold px-5 py-2.5 rounded-md text-center transition-colors whitespace-nowrap cursor-pointer"
            onClick={() => setMenuOpen(false)}
          >
            提交項目
          </a>
        </div>
      )}
    </nav>
  );
}
